/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgVehicleOn32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path fill='currentColor' d='M29 16a3 3 0 11-6 0 3 3 0 016 0z' />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M9.464 16c0 1.832-1.272 3-3.232 3C4.272 19 3 17.832 3 16s1.272-3 3.232-3c1.96 0 3.232 1.168 3.232 3zm-4.968 0c0 1.16.672 1.896 1.736 1.896S7.968 17.168 7.968 16s-.672-1.896-1.736-1.896-1.736.728-1.736 1.896z'
      />
      <path
        fill='currentColor'
        d='M11.635 18.84h-1.312v-5.68h1.568l2.36 3.256c.152.224.296.48.384.688h.016V13.16h1.312v5.68h-1.488l-2.448-3.296c-.136-.216-.296-.472-.376-.664h-.024c.008.24.008.488.008.76v3.2z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M6 10a6 6 0 000 12h20a6 6 0 000-12H6zm20 1.5H6a4.5 4.5 0 100 9h20a4.5 4.5 0 100-9z'
      />
    </svg>
  );
}

export default SvgVehicleOn32;
